import { getContentPath } from '../../../../../common/ContentPaths';

/**
 * Builds a mailto: link for requesting contributor access to an existing publication.
 * The email is addressed to the owner and co-authors of the publication.
 * Author emails are provided by the caller from the duplication check SSE response.
 */
export function buildContributorMailtoLink(
  contentTitle: string,
  contentId: string,
  authorEmails: string[],
): string {
  const recipients = [...new Set(authorEmails)].join(',');
  const readViewUrl = `${window.location.origin}${getContentPath({ contentId, mode: 'publication' })}`;

  const subject = `Request to be a contributor - ${contentTitle}`;

  const body = [
    `Hello. I am interested in becoming a coauthor of ${contentTitle} (${readViewUrl}) in APG Library so that I can contribute and help maintain the content. Could you please grant me coauthor permissions?`,
    '',
    'If you approve, please do the following to grant these permissions:',
    `1. In APG Library, open the My guidance page (${window.location.origin}/my-content).`,
    '2. Under "Content I created", select the applicable content.',
    '3. From the "Actions" menu, choose "Edit coauthors".',
    '4. Search for my name, alias, or email address.',
    '5. Choose "Add", and then choose "Save".',
    '',
    'Thank you for your consideration.',
  ].join('\r\n');

  return `mailto:${recipients}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
